import { onlinePaymentWaivers } from '@homevest/utils'
import axios from 'lib/axios'

type OnlinePaymentStatus = onlinePaymentWaivers.OnlinePaymentStatus
type OnlinePaymentWaiverRequest = onlinePaymentWaivers.OnlinePaymentWaiverRequest
type OnlinePaymentWaiverResult = onlinePaymentWaivers.OnlinePaymentWaiverResult

const rentalPath = (rentalId: string) => `/admin/rentals/${encodeURIComponent(rentalId)}`

export const onlinePaymentWaiversApi = {
  async getStatus(rentalId: string): Promise<OnlinePaymentStatus> {
    const { data } = await axios.get<OnlinePaymentStatus>(
      `${rentalPath(rentalId)}/online_payment_status`
    )
    return data
  },

  async waive(
    rentalId: string,
    request: OnlinePaymentWaiverRequest
  ): Promise<OnlinePaymentWaiverResult> {
    const { data } = await axios.post<OnlinePaymentWaiverResult>(
      `${rentalPath(rentalId)}/online_payment_waiver`,
      request
    )
    return data
  }
}
